import { PromoCodeTypeEnum } from '../models';

export const saleTypeTranslate: { [key in PromoCodeTypeEnum]: string } = {
  percentage: 'Porcentual',
  fixed: 'Fijo',
};
